require('../shared/singleGameService');
require('../shared/clipCategoryService');

angular.module('app.player.playerSharedDataService', [
  'app.shared.singleGameService',
  'app.shared.clipCategoryService',
])
  .factory('app.player.playerSharedDataService', [
    '$http',
    'app.shared.singleGameService',
    'app.shared.clipCategoryService',
    function ($http, singleGame, clipCategoryService) {
      "use strict";

      let service = {
        gameClips: null,
        clipCategories: [],
        clipSubcategories: [],
        getGameClips: (game_id) => {
          return singleGame.retrieveClips(game_id)
            .then((response) => {
              let data = response.data;

              if (!data.error) {
                service.gameClips = data;
              }

              return response;
            });
        },
        getClipCategories: () => {
          return clipCategoryService.getCategories()
            .then((response) => {
              let data = response.data;

              if (!data.error) {
                service.clipCategories = data;
              }

              return response;
            });
        },
        getClipSubcategories: () => {
          return clipCategoryService.getSubcategories()
            .then((response) => {
              let data = response.data;

              if (!data.error) {
                service.clipSubcategories = data;
              }

              return response;
            });
        },
        clear: () => {
          service.clipCategories = [];
          service.clipSubcategories = [];
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/playerSharedDataService.js